import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from '@ngx-translate/core';
import { TipoRelacionService } from 'src/app/dashboard/services/tipo-relacion.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Relacion } from 'src/app/dashboard/models/relacion';
import { CustomValidators } from 'src/app/shared/custom-validator/custom-validator.component';

@Component({
  selector: 'app-tipo-relacion',
  templateUrl: './tipo-relacion.component.html',
  styleUrls: ['./tipo-relacion.component.css']
})
export class TipoRelacionComponent implements OnInit {

  sociedad: string;
  relaciones: Relacion[] = [];
  IsHiddenForm: boolean = false;
  validatingForm: FormGroup;

  constructor(
    private apiService: TipoRelacionService,
    private router: Router,
    private auth: AuthService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    const language = this.auth.getLanguage() || 'es';
    this.translate.setDefaultLang(language);

    this.sociedad = this.auth.getNameSociedad();

    this.apiService
      .searchRelationTypeByUserSociety(this.auth.getSociedad(), language)
      .subscribe((relacion: Relacion[]) => {
        this.relaciones = relacion;
      });

    this.validatingForm = new FormGroup({
      signupFormModalName: new FormControl('', [
        Validators.required,
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑ.,()\-_\[\]\/"']{2,255}$/), // control más estricto y amigable
        CustomValidators.secureInput
      ]),
      signupFormModalId: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9_-]{1,100}$/),
        CustomValidators.secureInput
      ]),
      contactFormModalMessage: new FormControl('', [
        Validators.maxLength(4000),
        CustomValidators.secureInput
      ]),
    });
  }

  // Getters para facilitar acceso a los campos
  get signupFormModalName() {
    return this.validatingForm.get('signupFormModalName');
  }

  get signupFormModalId() {
    return this.validatingForm.get('signupFormModalId');
  }

  get contactFormModalMessage() {
    return this.validatingForm.get('contactFormModalMessage');
  }

  deleteRelationType(id_tp_relacion: string) {
    this.apiService.deleteRelationTypeByUser(this.auth.getSociedad(), id_tp_relacion).subscribe({
      next: res => {
        if (res.code === 200 && res.success) {
          this.toastr.success(this.translate.instant('texto_225'), this.translate.instant('texto_228'));
        } else {
          this.toastr.error(this.translate.instant('texto_226'), this.translate.instant('texto_813'));
        }
        this.recargarRuta();
      },
      error: err => {
        if (err.error.code === 409) {
          this.toastr.error(this.translate.instant('texto_227'), this.translate.instant('texto_813'));
        } else {
          this.toastr.error(this.translate.instant('texto_226'), this.translate.instant('texto_813'));
        }
      }
    });
  }

  hideModal() {
    this.IsHiddenForm = false;
  }

  showRelation(relation: Relacion) {
    this.IsHiddenForm = true;

    this.validatingForm.patchValue({
      signupFormModalId: relation.id_tp_relacion,
      signupFormModalName: relation.nombre,
      contactFormModalMessage: relation.comentario
    });

    // Activar labels flotantes si es necesario
    setTimeout(() => {
      document.querySelectorAll('label').forEach(label => label.classList.add('active'));
    }, 100);
  }

  updateRelation(id_tp_relacion: string) {
    if (this.validatingForm.invalid) {
      this.toastr.error(this.translate.instant('texto_230'), this.translate.instant('texto_231'));
      return;
    }

    const nombreRelacion = this.signupFormModalName.value;
    const comentario = this.contactFormModalMessage.value;
    const language = this.auth.getLanguage() || 'es';

    this.apiService
      .updateRelationByUser(this.auth.getSociedad(), id_tp_relacion, nombreRelacion, comentario, language)
      .subscribe(res => {
        if ((res as any).success === true) {
          this.toastr.success(this.translate.instant('texto_229'), this.translate.instant('texto_231'));
        } else {
          this.toastr.error(this.translate.instant('texto_230'), this.translate.instant('texto_231'));
        }
        this.recargarRuta();
      },
        err => {
          if (err.status === 409) {
            this.toastr.error(this.translate.instant('texto_230'), this.translate.instant('texto_813'));
          } else {
            this.toastr.error(this.translate.instant('texto_230'), this.translate.instant('texto_813'));
          }
        });
  }

  private recargarRuta() {
    this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/dashboard/layout/tipo-relacion']);
    });
  }

  public options: Object = {
    charCounterCount: true,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'html', 'backgroundColor', 'textColor', 'alignLeft', 'alignCenter', 'alignRight', 'insertLink', '|', 'undo', 'redo'],
    toolbarButtonsXS: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'html', 'backgroundColor', 'textColor', 'alignLeft', 'alignCenter', 'alignRight', 'insertLink', '|', 'undo', 'redo'],
    imageAllowedTypes: ['jpeg', 'jpg', 'png'],
    imageMaxSize: 5 * 1024 * 1024
  };
}
